import React, {Component} from 'react';

import {withRouter} from 'react-router-dom';
import REST from '../Shared/REST';
import '../assets/custom.css';
import Helpers from "../Shared/Helpers";
import {BUCKET_URL, MAIN} from "../Shared/Consts";
import "../assets/students/PictureNaming.css";
import DialogBox from "../Shared/DialogBox";

class PN1On1Student extends Component {

    constructor(props) {
        super(props);
        this.state = {
            testId: null,
            websocket: null,
            imageSrc: "",
            modalDialog: false,
            responseContent:'',
            currentIndex: 0,
            sessionData: {
                pn_pictures: []
            }
        };

        this.openWebSocket = this.openWebSocket.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        Helpers.authorize(this);
    };

    openWebSocket = () => {
        if (this.state.testId != null) {

            REST.getPNManualSession(this.state.testId).then(res => {
                this.setState({
                    sessionData: res.body
                });
                let authToken = localStorage.getItem('token');
                const socket = new WebSocket(MAIN.API.START_PICTURENAMING_WEBSOCKET + "?token=" + authToken + "&testId=" + this.state.testId);

                socket.addEventListener('open', (event) => {
                    this.setState({websocket: socket});
                    let studentMessage = JSON.stringify({status: true});
                    setTimeout(() => {
                        this.state.websocket.send(studentMessage);
                    }, 500)

                });

                socket.addEventListener('message', (event) => {
                    console.log('Message from server ', event);
                    let pic = JSON.parse(event.data);
                    this.setState({imageSrc: pic.url, currentIndex: pic.currentIndex});
                    if(pic.url === ""){
                        alert("Session has finished.");
                        this.props.history.goBack();
                    };
                });
            }).catch(e=>{
                console.log("Error",e);
                this.setState({
                    modalDialog: true,
                    responseContent:'Invalid assessment.'

                });
                setTimeout(()=>{this.setState({modalDialog:false})},2500);
            });

        } else {
            this.setState({
                modalDialog: true,
                responseContent:'Please enter the assessment Id in order to start the session.'

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        }
    };

    handleChange(evt) {
        this.setState({testId: evt.target.value});
    }

    render() {

        let imageNumerical = this.state.sessionData.pn_pictures.map((pnPic, index) => {
            return (
                <li key={index}
                    className={index <= this.state.currentIndex ? "item_done" : ""}>{(index + 1).toString()}</li>
            )
        });

        let imagesSlideshow = this.state.sessionData.pn_pictures.map((pnPic, index) => {
            return (
                <img key={index} hidden={this.state.currentIndex !== index || this.state.imageSrc === ""}
                     src={pnPic.url} alt="PNPicture"/>
            )
        });

        return (
            <div className="appSection bgGrey">
                <div className="container">
                    <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                    <div className="appContainer picturenaming">
                        <div className="row">
                            <h1>Picture Naming 1-1 Computer Task</h1>
                            <hr/>
                        </div>
                        <div hidden={this.state.websocket} className="row">
                            <div className={"col-md-3"}>
                                <input className={"input form-control inputStyle1"} type="text" placeholder={"Task ID"} onChange={this.handleChange}/>
                            </div>
                            <div className={"col-md-3"}>
                                <a className={"handBtn"} onClick={this.openWebSocket}><span>Join</span></a>
                            </div>
                        </div>
                        <div className="row tc">
                            <div className="col-sm-12 tc" style={{minHeight: 405 + "px"}}>
                                <br/>
                                {imagesSlideshow}
                                <br/>
                                <ul className="list_items" style={{marginTop:25}}>
                                    {imageNumerical}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(PN1On1Student);



// WEBPACK FOOTER //
// ./src/StudentsComponent/PN1On1Student.js